const CameraIcon = () => {
  return (
    // <a id="iconToReplace" className="newTwo" href="#" title="newTwo">
    <svg
 
     // style={{ width: "20px", height: "20px" }}
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      viewBox="0 0 256 256"
    >
      <rect width="256" height="256" fill="none"></rect>
      <path
        d="M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></path>
      <circle
        cx="128"
        cy="132"
        r="36"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></circle>
    </svg>
    // </a>
  );
};
export default CameraIcon;
